import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import persistState from "redux-localstorage";
import rootReducer from "reducers/rootReducer";
import rootSagas from "sagas/rootSaga";

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    /** Dev-only handle for driving the store by hand — see below. */
    __beamStore?: any;
  }
}
// Create sagas middleware
const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(initialState: any) {
  const sagaMiddleware = createSagaMiddleware();
  const enhancer = compose(applyMiddleware(sagaMiddleware));

  let store;
  if (process.env.NODE_ENV === "production") {
    store = createStore(rootReducer, initialState, enhancer);
  } else {
    store = createStore(
      rootReducer,
      composeEnhancers(
        applyMiddleware(sagaMiddleware),
      )
    );
    // Running sagas

    /*
      Some message types can only be produced by a device — a camera never
      comes from a modal in this app — which leaves their screens with no way
      to be exercised locally at all. Exposing the store in development gives
      one: an action can be dispatched from the console to stand in for the
      device until the real one is on the page.

      Development only, so nothing reaches a built bundle, and deliberately not
      a redux-devtools dependency — the hook works with a plain console.
    */
    window.__beamStore = store;
  }
  sagaMiddleware.run(rootSagas);
  return store;
}
